<template>
  <body class="jumbo-page  gradient-01">

<main class="admin-main">

    <section class="admin-content">

        <div class="container  ">
            <div class="row m-h-100 align-items-center justify-content-center">
                <div class="col-lg-6 col-md-10 p-t-80">
                    <div class="card shadow-lg">
                        <div class=" p-all-25">
                            <div class="pull-up-sm text-center p-b-30">
                                <div class="avatar avatar avatar-lg">
                                    <img src="assets/img/logo.svg" alt="">
                                </div>
                            </div>
                            <!-- <form id="commentForm" method="get" action="forms-wizard.html" class="form-horizontal">
                                <div id="rootwizard">

                                    <ul class="nav nav-pills nav-justified">
                                        <li class="nav-item"><a class="nav-link" href="#tab1" data-toggle="tab">Select HMO</a></li>
                                        <li class="nav-item"><a class="nav-link" href="#tab2" data-toggle="tab">Select
                                                Plans</a></li>
                                        <li class="nav-item"><a class="nav-link" href="#tab3" data-toggle="tab">
                                                Make Payment</a></li>
                                    </ul>

                                    <div class="tab-content">
                                        <div class="tab-pane p-t-20 p-b-20" id="tab1">

                                            <h3>
                                                <span class="align-middle">Welcome Linda, Complete your profile here</span></h3>
                                            <div class="form-group">
                                              <label for="inputCity">Select HMO</label>
                                                  <select class="form-control">
                                                   <option>Axard</option>
                                                   <option>Stanbic</option>
                                                   <option>Livly</option>
                                               </select>

                                            </div>
                                            <div class="form-group">
                                              <label for="inputCity">Select Provider</label>

                                                  <select class="form-control">
                                                   <option>General Hospital</option>
                                                   <option>Hospital 2</option>
                                                   <option>Hospital 3</option>
                                               </select>
                                            </div>
                                            <a class="nav-link" href="#tab2" data-toggle="tab">Proceed</a>

                                        </div>
                                        <div class="tab-pane p-t-20 p-b-20" id="tab2">
                                            <div class="option-box">
                                                <input id="radio-new1" name="bigradios" type="radio">
                                                <label for="radio-new1">
                                                    <span class="radio-content">
                                                        <span class="h6 d-block">Starter Plan <span class="badge-soft-primary badge">$12 MONTH</span>
                                                        </span>
                                                        <span class="text-muted m-b-41">
                                                            Lorem ipsum dolor sit amet, consectetur adipisicing
                                                            elit. Accusantium blanditiis ducimus ipsa provident
                                                            quae quaerat similique? Consequatur consequuntur
                                                            cum, inventore nihil porro quis. Ad assumenda
                                                            eligendi illum impedit quis totam.
                                                        </span>
                                                    </span>
                                                </label>
                                            </div>
                                            <div class="option-box">
                                                <input id="radio-new2" name="bigradios" type="radio">
                                                <label for="radio-new2">
                                                    <span class="radio-content">
                                                        <span class="h6 d-block">Pro Plan <span class="badge-soft-info badge">$49 MONTH</span>
                                                        </span>

                                                        <span class="text-muted m-b-41">
                                                            Lorem ipsum dolor sit amet, consectetur adipisicing
                                                            elit. Accusantium blanditiis ducimus ipsa provident
                                                            quae quaerat similique? Consequatur consequuntur
                                                            cum, inventore nihil porro quis. Ad assumenda
                                                            eligendi illum impedit quis totam.
                                                        </span>
                                                    </span>
                                                </label>
                                            </div>
                                            <a class="btn" href="#tab3" data-toggle="tab">Proceed</a>

                                        </div>
                                        <div class="tab-pane p-t-20 p-b-20" id="tab3">
                                            <div class="row">

                                                <div class="col m-b-30">
                                            <button class="btn">Payment 5,000</button>
                                                </div>

                                            </div>
                                        </div>
                                        <ul class="nav nav-pills justify-content-between wizard m-b-30">
                                            <li class=" nav-item next"><a class="nav-link btn-success"
                                                                          href="#!">Proceed</a></li>


                                        </ul>
                                    </div>
                                </div>
                            </form> -->
                            <p>ss</p>

                            <p class="text-center">
                                <a href="/client-dashboard" class="text-underline">Back to Dashboard</a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    </section>
</main>
  </body>
</template>

<script>
export default {
  data(){
    return{

    }
  },
  beforeMount(){

  },
  methods:{

  },
  created(){

  }

}
</script>
